import * as TabsPrimitive from '@radix-ui/react-tabs';
import type * as React from 'react';

export const TabsContent = ({
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) => (
  <TabsPrimitive.Content {...props} />
);
